import {http} from '@/http'

export default {
  list(data, params) {
    return http.post('/positions/list', data, {params})
  },
  listAll(data, params) {
    return http.get('/positions', data, {params})
  },
  changeStatus(id, status) {
    return http.put(`/positions/${id}/status`, null, {params: {status}})
  },
  save(data) {
    return http.post('/positions', data)
  },
  update(id, data) {
    return http.put(`/positions/${id}`, data)
  },
  get(id) {
    return http.get(`/positions/${id}`)
  },
  queryDni(dni) {
    return http.get(`/positions/dni/${dni}`)
  },
  download(data) {
    return http.post("/positions/xlsx", data, { responseType: "blob" });
  },
  queryRuc(ruc) {
    return http.get(`/positions/ruc/${ruc}`)
  }
}
